/**
 * Format currency amount
 * @param {number} amount - Amount in cents
 * @param {string} currency - Currency code (USD, EUR, etc.)
 */
export const formatCurrency = (amount, currency = 'USD') => {
  if (amount == null) return '$0.00';
  const curr = (currency || 'USD').toUpperCase();
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: curr
  }).format(amount / 100);
};

/**
 * Format date
 * @param {number} timestamp - Unix timestamp
 */
export const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  return new Date(timestamp * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

/**
 * Format date with time
 * @param {number} timestamp - Unix timestamp
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp) return 'N/A';
  return new Date(timestamp * 1000).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Get status badge class
 * @param {string} status - Subscription status
 */
export const getStatusBadgeClass = (status) => {
  const statusMap = {
    active: 'badge-success',
    canceled: 'badge-danger',
    past_due: 'badge-warning',
    trialing: 'badge-info',
    incomplete: 'badge-warning',
    incomplete_expired: 'badge-danger',
    unpaid: 'badge-danger'
  };

  return statusMap[status] || 'badge-info';
};

/**
 * Format number with commas
 * @param {number} num - Number to format
 */
export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};

/**
 * Calculate percentage
 * @param {number} value - Current value
 * @param {number} total - Total value
 */
export const calculatePercentage = (value, total) => {
  if (!total) return 0;
  return ((value / total) * 100).toFixed(1);
};
